import * as React from 'react';
import { connect } from 'react-redux';
import { Dispatch } from 'redux';
import Store from '../../../Store';
import ModuleImageSettings, { Props } from '../_components/ModuleImageSettings';
import { ModuleOnValueUpdate, ModuleOnMultipleValueUpdate } from '../../_actions/ModuleActions';
import { IImageStore } from '../../../ImageList/_stores/ImageStore';
import { ImageListAdd, ImageListRemove } from '../../../ImageList/_actions/ImageListActions';
import { OnModuleRemove } from '../../../ModuleList/_actions/ModuleListActions';
import { OnChangeWidth, OnChangeHeight, OnChangeLockRatio, OnAttachModule } from '../../../Document/_actions/DocumentActions';

const mapStateToProps = (store:Store, props:Props) => ({
	source: store.getIn(['create', 'moduleList', 'modules', props.moduleId, 'source']),
	moduleCount: store.get('create').get('moduleList').get('modules').count(),
	sourceRatio: store.getIn(['create', 'moduleList', 'modules', props.moduleId, 'sourceRatio']),
	sourceWidth: store.getIn(['create', 'moduleList', 'modules', props.moduleId, 'sourceWidth']),
	sourceHeight: store.getIn(['create', 'moduleList', 'modules', props.moduleId, 'sourceHeight']),
	width: store.getIn(['create', 'moduleList', 'modules', props.moduleId, 'width']),
	height: store.getIn(['create', 'moduleList', 'modules', props.moduleId, 'height']),
	rotation: store.getIn(['create', 'moduleList', 'modules', props.moduleId, 'rotation']),
	documentWidth: store.getIn(['create', 'document', 'width']),
	documentHeight: store.getIn(['create', 'document', 'height']),
	isAttached: store.getIn(['create', 'document', 'attachedModule']) === props.moduleId,
});

const mapDispatchToProps = (dispatch:Dispatch, props:Props) => ({
	onThumbnailChange: (thumbnail:string) => dispatch(ModuleOnValueUpdate(props.moduleId, 'thumbnail', thumbnail)),
	onImageListAdd: (image:IImageStore) => dispatch(ImageListAdd(image)),
	onImageListRemove: (id:string) => dispatch(ImageListRemove(id)),
	removeModule: (id:string) => dispatch(OnModuleRemove(props.moduleId)),
	setDocumentWidth: (width:number) => dispatch(OnChangeWidth(width)),
	setDocumentHeight: (height:number) => dispatch(OnChangeHeight(height)),
	toggleLockRatio: (lockRatio: boolean) => dispatch(OnChangeLockRatio(lockRatio)),
	updateModule: (moduleId:string, updates:{[key:string] : any}) => dispatch(ModuleOnMultipleValueUpdate(moduleId, updates)),
});

export default connect(
	mapStateToProps,
	mapDispatchToProps
)(ModuleImageSettings);